'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconInwardSquaresThree, iconInwardSquaresThreeTag } from '@ni/nimble-components/dist/esm/icons/inward-squares-three';
import { wrap } from '../../utilities/react-wrapper';

export type { IconInwardSquaresThree };
export { iconInwardSquaresThreeTag };
export const NimbleIconInwardSquaresThree = wrap(IconInwardSquaresThree);